const MENTION_BLACKLIST = new Set([
  'google', 'linkedin', 'youtube', 'facebook', 'twitter', 'instagram', 'tiktok',
  'microsoft', 'apple', 'amazon', 'meta', 'semrush', 'clutch', 'hubspot',
  'salesforce', 'ahrefs', 'moz', 'bing', 'yahoo', 'tbd',
])

export function filterMentionPills(brands: string[]): string[] {
  // ai_mentioned_brands and competitor_mentions come from the API as the same
  // underlying list under two field names — callers concatenate both, so
  // dedupe by case-insensitive exact match before the substring filter below.
  const seen = new Set<string>()
  const deduped = brands.filter((b) => {
    const key = b.trim().toLowerCase()
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
  const filtered = deduped.filter((b) => {
    const t = b.trim()
    return t.length >= 4 && !MENTION_BLACKLIST.has(t.toLowerCase())
  })
  return filtered.filter(
    (brand, _, arr) => !arr.some((other) => other !== brand && other.toLowerCase().includes(brand.toLowerCase()) && other.length > brand.length)
  )
}

// competitor_mentions is sanitized server-side against hostile content but
// not against the tenant's OWN brand — models sometimes list the brand being
// asked about as if it were a competitor. Filter it out client-side using
// every name we have for "self": the demo result's server-resolved brand
// name, the raw host, and the bare domain label (host minus www. and TLD).
export function excludeOwnBrand(names: string[], opts: { host?: string | undefined; brandName?: string | undefined }): string[] {
  const self = new Set<string>()
  if (opts.brandName) self.add(opts.brandName.trim().toLowerCase())
  if (opts.host) {
    const host = opts.host.trim().toLowerCase()
    self.add(host)
    const bare = host.replace(/^www\./, '').replace(/\.[a-z]{2,}$/, '')
    if (bare) self.add(bare)
  }
  return names.filter((n) => !self.has(n.trim().toLowerCase()))
}
